// Handlers for settings related actions

import type {
  SetAccountTooltipsAction,
  SetDataCollectionSettingsAction,
  SetSubscriptionsStatusAction,
  SetUserAnalyticsAction,
  UpdateAdvancedColorAction,
  UpdateBackgroundSettingsAction,
  UpdateMarkupAction,
  UpdateThemeAction,
  UserState,
} from './types';

export const setUserAnalyticsHandler = (
  state: UserState,
  { payload }: SetUserAnalyticsAction,
): UserState => {
  return {
    ...state,
    stats: {
      analyticsData: {
        ...state.stats?.analyticsData,
        ...payload?.analyticsData,
      },
      loading: payload?.loading ?? false,
    },
  };
};

export const updateBackgroundSettingsHandler = (
  state: UserState,
  { payload }: UpdateBackgroundSettingsAction,
): UserState => {
  return {
    ...state,
    backgroundSettings: { ...state.backgroundSettings, ...payload },
  };
};

export const setSubscriptionsStatusHandler = (
  state: UserState,
  { payload }: SetSubscriptionsStatusAction,
): UserState => {
  return {
    ...state,
    subscriptions: payload,
  };
};

export const setAccountTooltipsHandler = (
  state: UserState,
  { payload }: SetAccountTooltipsAction,
): UserState => {
  return {
    ...state,
    tooltips: [...state.tooltips, payload],
  };
};

export const updateThemeHandler = (
  state: UserState,
  { payload }: UpdateThemeAction,
): UserState => {
  return {
    ...state,
    backgroundSettings: { ...state.backgroundSettings, ...payload },
  };
};

export const updateMarkupHandler = (
  state: UserState,
  { payload }: UpdateMarkupAction,
): UserState => {
  return {
    ...state,
    backgroundSettings: {
      ...state.backgroundSettings,
      markup: { ...state.backgroundSettings?.markup, ...payload },
    },
  };
};

export const updateAdvancedColorHandler = (
  state: UserState,
  { payload }: UpdateAdvancedColorAction,
): UserState => {
  return {
    ...state,
    backgroundSettings: {
      ...state.backgroundSettings,
      advancedColor: {
        ...state.backgroundSettings?.advancedColor,
        ...payload,
      },
    },
  };
};

export const setDataCollectionSettingsHandler = (
  state: UserState,
  { payload }: SetDataCollectionSettingsAction,
): UserState => {
  return {
    ...state,
    dataCollectionSettings: { ...state.dataCollectionSettings, ...payload },
  };
};
